<div class="d-flex align-items-center auth px-0">
    <div class="row w-100 mx-0">
        <div class="col-12 col-lg-10 col-xl-6 mx-auto">
            <div class="text-left py-5 px-4 px-sm-5">
                <div class="brand-logo">
                    <img src="assets/images/logo.svg" alt="agaia logo">
                </div>
                <div class="heading-text">
                    <h4>{{'auth_login_title' | localise}}</h4>
                    <h6 class="font-weight-light">{{ 'auth_login_text' | localise }}</h6>
                </div>
            </div>
        </div>
    </div>
</div>  
